import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { ListBoxItem } from 'react-aria-components';

const listBoxItem = "_list-box-item_1kwcn_1";
const styles = {
	listBoxItem: listBoxItem
};

const TypeaheadItem = (_a) => {
  var { children, className, id, size = "large", textValue } = _a, props = __rest(_a, ["children", "className", "id", "size", "textValue"]);
  const childrenIsPureText = React.useMemo(() => React.Children.toArray(children).every((child) => typeof child === "string" || typeof child === "number"), [children]);
  if (!childrenIsPureText && !textValue) {
    console.error("Typeahead.Item: The `textValue` prop must be set if `children` is not plain text.");
  }
  return React.createElement(ListBoxItem, Object.assign({ className: clsx(className, styles.listBoxItem), "data-size": size, "data-zds": true, id, textValue }, props), children);
};

export { TypeaheadItem };
//# sourceMappingURL=TypeaheadItem.es.js.map
